export const DAY_STATUSES = ["full", "half", "none", "sick", "holiday"];
export function billableWeight(status) {
    if (status === "full")
        return 1;
    if (status === "half")
        return 0.5;
    return 0;
}
//# sourceMappingURL=status.js.map